"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSimpleReducer = void 0;
var react_1 = require("react");
var useIfMounted_1 = require("./hooks/useIfMounted");
// A user-defined type guard to check whether the initialState is a Promise
function isInitialStatePromise(initialState) {
    return initialState && Object.prototype.toString.call(initialState) === '[object Promise]';
}
function useSimpleReducer(initialState, actions, useState) {
    if (useState === void 0) { useState = react_1.useState; }
    react_1.useEffect(function () {
        if (isInitialStatePromise(initialState)) {
            initialState.then(function (response) {
                setState(response);
                currentState.current = response;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _a = useState(initialState), state = _a[0], setState = _a[1];
    var _b = useState({ isActive: false, runningAction: null, pendingActions: [] }), queue = _b[0], setQueue = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var currentQueue = react_1.useRef([]).current;
    var ifMounted = useIfMounted_1.default();
    var isProccessing = react_1.useRef(false);
    var currentState = react_1.useRef(state);
    var methods = {};
    var _loop_1 = function (actionName) {
        if (Object.prototype.hasOwnProperty.call(actions, actionName)) {
            methods[actionName] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                currentQueue.push({
                    actionName: actionName,
                    action: actions[actionName],
                    args: args,
                });
                if (!isProccessing.current) {
                    isProccessing.current = true;
                    runNext();
                }
            };
        }
    };
    // implementation
    for (var actionName in actions) {
        _loop_1(actionName);
    }
    function runNext() {
        var actionAndArgs = currentQueue.shift();
        if (actionAndArgs !== undefined) {
            setQueue(__assign(__assign({}, queue), { isActive: true, runningAction: actionAndArgs, pendingActions: __spreadArray([], currentQueue) }));
            actionAndArgs
                .action.apply(actionAndArgs, __spreadArray([currentState.current], actionAndArgs.args)).then(function (latestState) {
                ifMounted(function () {
                    currentState.current = latestState;
                    setError(null);
                    setState(latestState);
                    runNext();
                });
            })
                .catch(function (err) {
                ifMounted(function () {
                    var pendingActions = __spreadArray([], currentQueue);
                    currentQueue.splice(0, currentQueue.length);
                    isProccessing.current = false;
                    setQueue(__assign(__assign({}, queue), { isActive: false, runningAction: null, pendingActions: [] }));
                    setError({
                        reason: err,
                        failedAction: actionAndArgs,
                        pendingActions: pendingActions,
                        runFailedAction: function () { return runActions([actionAndArgs]); },
                        runPendingActions: function () { return runActions(pendingActions); },
                        runAllActions: function () { return runActions(__spreadArray([actionAndArgs], pendingActions)); },
                    });
                });
            });
        }
        else {
            isProccessing.current = false;
            setQueue(__assign(__assign({}, queue), { isActive: false, runningAction: null, pendingActions: [] }));
        }
    }
    function runActions(actionsAndArgs) {
        currentQueue.push.apply(currentQueue, actionsAndArgs);
        runNext();
    }
    return [state, methods, queue, error];
}
exports.useSimpleReducer = useSimpleReducer;
